
import axios from 'axios';
import { getAccessToken,setAccessToken } from './accessToken';
import jwtDecode from 'jwt-decode';

const xaxios = {
    async get(...args) {
        await autotoken();
      try {
        const response = await axios.get(...args);
        return response;
      } catch (error) {
        window.console.log('>>>>>ERROR GET::', error);
        throw error;
      }
    },

    async post(...args) {
        await autotoken();
        try {
          const response = await axios.post(...args);
          return response;
        } catch (error) {
          throw error;
        }
    },

    async patch(...args) {
        await autotoken();
        try {
          const response = await axios.patch(...args);
          return response;
        } catch (error) {
          throw error;
        }
    },

    async put(...args) {
      await autotoken();
      try {
        const response = await axios.put(...args);
        return response;
      } catch (error) {
        throw error;
      }
  },

    async delete(...args) {
        await autotoken();
        try {
          const response = await axios.delete(...args);
          return response;
        } catch (error) {
          throw error;
        }
    },
    async request(...args) {
        await autotoken();
        try {
          const response = await axios.request(...args);
          return response;
        } catch (error) {
          throw error;
        }
    },
};

const autotoken = async() => {
    let xtoken = getAccessToken();
    const decodedToken = jwtDecode(xtoken);
    const ahoraEnSegundos = Math.floor(Date.now() / 1000);
    const restante = decodedToken.exp - ahoraEnSegundos;
    axios.defaults.headers.common = { Authorization:xtoken };
    if (restante < 60 ){ // menor a 60 segundos
        let token = await re_login();
        // window.console.log(token);
        axios.defaults.headers.common = { Authorization:token };
        setAccessToken(token);
        // window.console.log("refresh:::", token);
    }
    return 0;
};

const re_login = async () => { 
    const ocultito = window.localStorage.getItem('USERDATALOGIN');
    let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
    let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
    const datauser = plaintext;
    var u = JSON.parse(datauser);
    if (!u) return; 
  
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    var raw = JSON.stringify({ username: u.user, password: u.clave });
    var requestOptions = { method: 'POST', headers: myHeaders, body: raw };
  
    let res = await fetch(process.env.VUE_APP_AUTH_POST, requestOptions)
      .then((response) => response.json())
      .then( result=> result )
      .catch((error) => error);
    if( res && res.accessToken ){
        return res.accessToken;
    }
    return 'no access token :('; 
  };

export default xaxios;